const actions = {
  // Lista Notas Fiscal

  listarNotas: async (
    context,
    {
      initial_date,
      pedido_compra,
      solicitacao_compra,
      status,
      vendor_id,
      page,
      per_page,
      numero,
      nf_pedido_vinculado,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`nf`, {
      params: {
        initial_date,
        pedido_compra,
        solicitacao_compra,
        status,
        vendor_id,
        page,
        per_page,
        numero,
        nf_pedido_vinculado,
      },
    });

    return response;
  },

  listarEntradasNf: async (
    context,
    {
      vendor_id,
      data_inicial,
      data_final,
      codigo_produto_fornecedor,
      numero_nota,
      provider_search,
      search,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`nf/listagem`, {
      params: {
        vendor_id,
        data_inicial,
        data_final,
        codigo_produto_fornecedor,
        numero_nota,
        provider_search,
        search,
      },
    });

    return response;
  },

  exportarEntradasNf: async (
    context,
    {
      download,
      page,
      vendor_id,
      data_inicial,
      data_final,
      search,
      provider_search,
      numero_nota,
      codigo_produto_fornecedor,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`nf/listagem`, {
      params: {
        download,
        page,
        vendor_id,
        data_inicial,
        data_final,
        search,
        provider_search,
        numero_nota,
        codigo_produto_fornecedor,
      },
    });

    return response;
  },

  cancelarNota: async (context, { action, nf_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`nf/${nf_id}/${action}`);

    return response;
  },

  listarCentrosCustos: async (context, { vendor_id, per_page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cost-centers`, {
      params: {
        vendor_id,
        per_page,
        search,
      },
    });

    return response;
  },

  gerarEntrada: async (context, { cost_center_id, nota_fiscal, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`nf/from-xml`, {
      cost_center_id,
      nota_fiscal,
      vendor_id,
    });

    return response;
  },

  // Editar Nota

  editarNota: async (context, { nota_id, initial_date }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`nf/${nota_id}`, {
      params: {
        initial_date,
      },
    });

    return response;
  },

  adicionarImagem: async (context, { imagem, nf_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`nf/imagem`, {
      imagem,
      nf_id,
    });

    return response;
  },

  deletarImagemNota: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`nf/imagem/${uuid}`);

    return response;
  },

  editarDadosNota: async (
    context,
    { nf_id, pedido_compra, solicitacao_compra }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`nf/${nf_id}`, {
      pedido_compra,
      solicitacao_compra,
    });

    return response;
  },

  editarDadosProduto: async (
    context,
    {
      nf_id,
      product_id,
      business_amount,
      business_value,
      product_code,
      validade,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`nf/${nf_id}/products/${product_id}`, {
      business_amount,
      business_value,
      product_code,
      validade,
      nf_id,
      product_id,
    });

    return response;
  },

  finalizarNota: async (context, { nf_id, batches }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`nf/${nf_id}/finish`, {
      nf_id: nf_id,
      action: "finish",
      batches,
      data_recebimento: new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
    });

    return response;
  },

  deletarProduto: async (context, { nf_id, product_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`nf/${nf_id}/products/${product_id}`, {});

    return response;
  },
  //Entrada Manual

  listarFornecedores: async (context, { per_page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`providers`, {
      params: {
        per_page,
        search,
      },
    });

    return response;
  },

  salvarCabecalho: async (
    context,
    {
      cost_center_id,
      data_emissao,
      format,
      informacoes_complementares,
      numero,
      provider_id,
      serie,
      tipo,
      vendor_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`nf`, {
      cost_center_id,
      data_emissao,
      format,
      informacoes_complementares,
      numero,
      provider_id,
      serie,
      tipo,
      vendor_id,
    });

    return response;
  },

  adicionarProdutosNota: async (context, { nf_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`nf/${nf_id}/products`, {
      products,
    });

    return response;
  },
  adicionarFornecedor: async (
    context,
    { business_name, cnpj, fantasy_name }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`providers`, {
      business_name,
      cnpj,
      fantasy_name,
    });

    return response;
  },

  vincularPedido: async (
    context,
    { uuid_item_nf, quantidade, uuid_item_pedido }
  ) => {
    let itens = [{ uuid_item_nf, quantidade, uuid_item_pedido }];
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/nf/vincular-pedido`, {
      itens,
    });

    return response;
  },

  desvincularPedido: async (context, { uuid_item_nf, uuid_item_pedido }) => {
    let itens = [{ uuid_item_nf, uuid_item_pedido }];
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/nf/desvincular-pedido`, {
      itens,
    });

    return response;
  },
};

export const notaFiscal = {
  namespaced: true,
  actions,
};
